class NewsItem{
    constructor(linkText,titles,articleLinks){
        this.linkText=linkText;
        this.titles=titles;
        this.articleLinks=articleLinks;
    }
}

export default NewsItem;